// extracted by mini-css-extract-plugin
export var infoItem = "_sw-2";
export var title = "_sw-0";
export var value = "_sw-1";